import React, { useContext, useState } from 'react';
import { Box } from '@mui/material';
import { Check, CheckBoxOutlineBlank} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import {ReactComponent as WarningIcon} from '../../../../img/warning.svg';
import AlertDialog from '../../../../components/AlertDialog';
import { MenuButtonStyle } from './styles';
import { DashboardContext } from '../../DashboardContext';
import ToolButton from '../../../../components/ToolButton';

const PrimaryDashboard = () => {
    const { t } = useTranslation();
    const { currentDashboard, toggleDefault } = useContext(DashboardContext);
    const [ showDefaultError, setShowDefaultError ] = useState<boolean>(false);
    
    const buttonAction = () => {
        if(currentDashboard?.dashboard.isDefault){
            setShowDefaultError(true);
        } else {
            toggleDefault();
        }
    }

    return (
        <>
            <ToolButton 
                hideTextOnMobileView={false}
                buttonStyle={{...MenuButtonStyle, 
                    ...(currentDashboard?.dashboard.isDefault
                    ? {
                        color: 'primary.main',
                    }
                    : {
                        color: 'text.secondary',
                        backgroundColor: 'background.paper',
                    }),
                }}
                iconElement={
                    currentDashboard?.dashboard.isDefault ? 
                        <Check/> : 
                        <CheckBoxOutlineBlank/>
                }
                onClick={buttonAction}
                text={t('screens.dashboarding.primary')}
                tooltip={t('screens.dashboarding.primary')}
                active={currentDashboard?.dashboard.isDefault}
            /> 
            <AlertDialog 
                open={showDefaultError} 
                title={t("screens.dashboarding.defaultError.title")}
                description={t("screens.dashboarding.defaultError.content")}
                confirmButtonText={t("actions.gotIt")}
                paperSx={{padding: "16px", minWidth: "500px"}}
                textAlign="center"
                confirmAction={() => setShowDefaultError(false)}
                icon={<Box><WarningIcon /></Box>}
                showCloseButton
                closeAction={() => setShowDefaultError(false)}
            />
        </>
    );
}


export default PrimaryDashboard;
